import { createAsyncSlice } from '../../createAsyncSlice';
import { updatePartiesAsync } from 'API/order/OrderUpdateAPI';

export const { slice: partiesActionsSlice, asyncAction: executePartiesActions } = createAsyncSlice(
  'partiesActionsSlice',
  updatePartiesAsync
);
